import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ApiserviceService } from '../core/services/apiservice.service';
import { ActivatedRoute } from '@angular/router';
import html2PDF from 'jspdf-html2canvas';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.scss']
})
export class PrintComponent implements OnInit {
  @ViewChild('printButton', { static: false }) printButton!: ElementRef;
  seciliresim:any;
  urunbilgi: any = [];
  urunresim: any = [];
  pageId:any;
  constructor(private api:ApiserviceService,private rota:ActivatedRoute) { }

  ngAfterViewInit(): void {
    // Sayfa yüklendikten sonra yazdırma işlemini tetikleyin
    this.printButton.nativeElement.click();
  }


tikla(){
  let page = document.getElementById('page');
  //const content=this.page;
  console.log(page)
  html2PDF(page, {
    jsPDF: {
      format: 'a4', // PDF formatı A4
      unit: 'mm',   // Birim olarak milimetre
      orientation: 'portrait', // Dikey yazdırma
    },
    imageType: 'image/jpeg', // Resim tipi
    html2canvas: {
      scale: 4, // Resimlerin çözünürlüğünü artırmak için ölçekleme
      useCORS: true, // Çapraz kaynaklardan gelen resimlerin yüklenmesini sağlar
    },
   

    output: './pdf/generate.pdf'
  });
}

  ngOnInit(): void {
    //this.pageId = this.rota.snapshot.paramMap.get('id'); 
    this.pageId="423051"
    this.urunbul()
    console.log(this.pageId)
    //this.tikla();
  }

  resmebak(index :string){
    this.seciliresim=index
    console.log(index)
  }
  urunbul(){
    const urun = {
      urunkodu:this.pageId
    };
    const urunbilgi2 = [];

    this.api.post('urunler/urunsorgula',urun).then((bsvdata:any) => {
       const urunbilgi2 = bsvdata.data;
        const urun_resim_bilgi =[]
        this.api.post('urunler2/urunsorgula',urun).then((urunresim:any) => {
        const urun_resim_bilgi = urunresim.data;
        this.urunbilgi = [];
        urunbilgi2.forEach(urn => {
        let urunler2_bul = urun_resim_bilgi.find(urunler2_bul=> urn.urun_id === urunler2_bul.urun_id )  
     
          
            this.urunbilgi.push({
          
              resim_dosyasi:this.api.mediaUrl+urunler2_bul.img_path,
              urun_adi:urn.urunadi,
              kategori:urn.kategori,
              koleksiyon:urn.koleksiyon,
              urunkodu:urn.urunkodu,
              malzeme:urn.malzeme,
              teknik:urn.teknik,
              hikaye:urn.hikaye,
              urun_id:urn.urun_id

              
            });
            console.log(this.urunbilgi)
            this.seciliresim=this.urunbilgi[0].resim_dosyasi
         }) 
         
    });
  })
  this.urun_resimleri(urun.urunkodu) 
  }
  urun_resimleri(event){
    const urun2 = {
      urunkodu:event,
    };
      this.api.post('urunler2/urunsorgula',urun2).then((urnresdata:any) => {
        const urunresimgetir=urnresdata.data
        console.log(urunresimgetir)
        this.urunresim = [];
        urunresimgetir.forEach(urn => {
          this.urunresim.push({
              id:urn.id,
              resim_dosyasi:this.api.mediaUrl+urn.img_path,
              urun_id:urn.urun_id
            });
            console.log(this.urunresim)
         }) 
      });
  }



}
